import type { FaireProductEntity } from "../../entity_types/product";

export const p_3e4byj2gqe: FaireProductEntity = {
  token: "p_3e4byj2gqe",
  type: "product",
  name: "Cunty Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/88abb453b7ef3e3b9dc30282a0e1c48fafa969be2bae82f785528d34532f26cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0f7777a15195912799b1d33c1c011cfbb68e26ddf10195bd883353be6a7aa16.jpeg",
    "https://cdn.faire.com/fastly/b5601f088a385e7cb07b5a3fca3add22a37461f45412f74b487b5470b7b5fc5f.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/b6cdc5627207fa6d891f9187907725ac6b4fb647ecfb74f20ce7ac168415e26f.jpeg",
    "https://cdn.faire.com/fastly/bfdaf941306b8361b7eb2e0ac85eaf83b37e8b5c4349edd65bf6b5c23ef29e83.jpeg"
  ],
  priceDollars: 6.75,
  description: "Not everyone can pull off being cunty. Luckily, you can always pull on these socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:06.358Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
